import client from "./client";

export default {
    async getLandlordInvoices(filters) {
        return client.parseResponse(await client.get('/landlord-invoices', filters));
    },

    async markLandlordInvoicePaid(id, data) {
        return client.parseResponse(await client.post(`/landlord-invoices/${id}/mark-paid`, data));
    },
}
